import { FormGroup, Radio } from '~/components/unform'
import { usePaymentTypes } from '~/modules/retailMedia/hooks/usePaymentTypes'
import { useRechargeForm } from '~/modules/retailMedia/pages/walltets/recharge/hooks/useRechargeForm'

import getMethodOption from './options'

const MultiMethodSection = () => {
  const { data: paymentTypes } = usePaymentTypes()

  const { handleChangePaymentMethod, balanceMarketplaceIsInsufficient } =
    useRechargeForm()

  const paymentOptions = getMethodOption({
    allowedTypes: paymentTypes,
    disabledOptions: balanceMarketplaceIsInsufficient ? ['marketplace'] : []
  })

  const onChangePaymentMethod = (e: React.ChangeEvent<HTMLInputElement>) =>
    handleChangePaymentMethod(e.target.value as PaymentMethod)

  return (
    <FormGroup className="span2">
      <Radio
        options={paymentOptions}
        name="payment_method"
        required
        itemSize="small"
        layout="default"
        onChange={onChangePaymentMethod}
      />
    </FormGroup>
  )
}

export default MultiMethodSection
